import { Modal } from "ui/Modal/Modal";
import { Spinner } from "ui/Spinner/Spinner";

export type SpinnerModalProps = {
  isOpen: boolean;
};

export function SpinnerModal({ isOpen = false }: SpinnerModalProps) {
  return (
    <Modal
      onClose={() => {}}
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
    >
      <Modal.Content width="auto" p="s200">
        <Spinner />
      </Modal.Content>
    </Modal>
  );
}
